export default "__VITE_ASSET__C8BXNOuv__"